function LdapQueryCtrl($scope, $timeout){
    $scope.users = {
        requestType:"OBJECT_ID"
    }
    $scope.users.ldapRequest = {
        loading: false,
        page_index: 0,
        page_size: 20
    };
    $scope.users.ldapRequest.types =  {
        EMAIL: "EMAIL",
        OBJECT_ID: "OBJECT_ID"
    };
    $scope.users.syncing ={
        loading:false,
        syncButtonClicked:false,
        approveButtonClicked:false,
    };
    $scope.groups = {
        requestType:"OBJECT_ID"
    };
    $scope.groups.ldapRequest = {
        loading: false,
        page_index: 0,
        page_size: 20,
        members: {
            page_index: 0,
            page_size: 20
        }
    };
    $scope.groups.ldapRequest.types =  {
        NAME: "NAME",
        OBJECT_ID: "OBJECT_ID"
    };
    $scope.groups.syncing ={
        loading:false,
        syncButtonClicked:false,
        approveButtonClicked:false,
        result:"",
    };

    $scope.getUsersByEmail = function () {
        $scope.sendRequest('GET',
            '/ag/getLdapUsersByEmail',
            $scope.users.ldapRequest.accountId,
            [['email', $scope.users.ldapRequest.param],
                ['page', $scope.users.ldapRequest.page_index],
                ['pageSize', $scope.users.ldapRequest.page_size]],
            $scope.users)
            .then(result => {
                $scope.users.queryResult = result;
            });
    };

    $scope.getUsersByObjectsId = function () {
        $scope.sendRequest('GET',
            '/ag/getLdapUsersByObjectsId',
            $scope.users.ldapRequest.accountId,
            [['objectsId', $scope.users.ldapRequest.param],
                ['page', $scope.users.ldapRequest.page_index],
                ['pageSize', $scope.users.ldapRequest.page_size]],
            $scope.users)
            .then(result => {
                $scope.users.queryResult = result;
            });
    };

    $scope.getGroupsByObjectsId = function () {
        $scope.sendRequest('GET',
            '/ag/getLdapGroupsByObjectsId',
            $scope.groups.ldapRequest.accountId,
            [['objectsId', $scope.groups.ldapRequest.param],
                ['page', $scope.groups.ldapRequest.page_index],
                ['pageSize', $scope.groups.ldapRequest.page_size],
                ['membersPage', $scope.groups.ldapRequest.members.page_index],
                ['membersPageSize', $scope.groups.ldapRequest.members.page_size]],
            $scope.groups)
            .then(result => {
                $scope.groups.queryResult = result;
            });
    };

    $scope.groups.syncGroup = function () {
            let path;
            let parameterName;
            if ($scope.groups.ldapRequest.requestType === $scope.groups.ldapRequest.types.OBJECT_ID) {
                path = '/ag/syncUsersServiceWithLdapGroupsByObjectsId';
                parameterName = "objectsId";
            } else if ($scope.groups.ldapRequest.requestType === $scope.groups.ldapRequest.types.NAME) {
                path = '/ag/syncUsersServiceWithLdapGroupsByNameLike';
                parameterName = "name";
            } else {
                return;
            }

        $scope.$root.confirm('Are you sure you want to sync group: ' + $scope.groups.ldapRequest.param + ' of account ' + $scope.groups.ldapRequest.accountId + ' on CC2 to Users Service?', function () {
            $scope.sendRequest('PUT',
                path,
                $scope.groups.ldapRequest.accountId,
                [[parameterName, $scope.groups.ldapRequest.param]],
                $scope.groups.syncing)
                .then(result => {
                    if (result == null) {
                        $scope.groups.syncing.result = {"Status": "Synced - Users Service will handle the entity in the next few seconds"};
                        $scope.groups.syncing.syncButtonClicked = false;
                    } else {
                        $scope.groups.syncing.result = result;
                    }
                });
        });
    };

    $scope.users.syncUser = function () {
        let path;
        let parameterName;
        if ($scope.users.ldapRequest.requestType === $scope.users.ldapRequest.types.OBJECT_ID) {
            path = '/ag/syncUsersServiceWithLdapUsersByObjectsId';
            parameterName = "objectsId";
        } else if ($scope.users.ldapRequest.requestType === $scope.users.ldapRequest.types.EMAIL){
            path = '/ag/syncUsersServiceWithLdapUsersByEmail';
            parameterName = "email";
        } else {
            return;
        }

        $scope.$root.confirm('Are you sure you want to sync user: ' + $scope.users.ldapRequest.param + ' of account ' + $scope.users.ldapRequest.accountId + ' on CC2 to Users Service?', function () {
            $scope.sendRequest('PUT',
                path,
                $scope.users.ldapRequest.accountId,
                [[parameterName, $scope.users.ldapRequest.param]],
                $scope.users.syncing)
                .then(result => {
                    if (result == null) {
                        $scope.users.syncing.result = {"Status": "Synced - Users Service will handle the entity in the next few seconds"};
                        $scope.users.syncing.syncButtonClicked = false;
                    } else {
                        $scope.users.syncing.result = result;
                    }
                });
        });
    };

    $scope.groupsContainingName = function () {
        $scope.sendRequest('GET',
            '/ag/getLdapGroupsByNameLike',
            $scope.groups.ldapRequest.accountId,
            [['name', $scope.groups.ldapRequest.param],
                ['page', $scope.groups.ldapRequest.page_index],
                ['pageSize', $scope.groups.ldapRequest.page_size],
                ['membersPage', $scope.groups.ldapRequest.members.page_index],
                ['membersPageSize', $scope.groups.ldapRequest.members.page_size]],
            $scope.groups)
            .then(result => {
                $scope.groups.queryResult = result;
            });
    };

    $scope.sendRequest = function(httpMethod, path, accountId, paramsMatrix, objectWithLoading) {
        return new Promise((resolve, reject) => {
            objectWithLoading.loading = true;
            return store.fetch({method: httpMethod,
                url: path + '?accountId=' + accountId + '&' + paramsMatrix.map(params => params.join('=')).join('&'),
                success: function success(data) {
                    $timeout(function () {
                        objectWithLoading.loading = false;
                        resolve(data);
                    }, 0);

                },
                error: function error(data) {
                    objectWithLoading.loading = false;
                    resolve({"Error": "Internal Server Error. (maybe Account ID does not exist)"});
                }
            });
        });
    }
}
